class WidgetLogoCarousel {
	init() {
		if (jQuery('.ll_logo_carousel_logos').length > 0) {
			setInterval(function () {
				jQuery('.ll_logo_carousel_logos').each(function () {
					if (
						jQuery(this).children('.ll_logo_carousel_logos_item_wrapper')
							.length > 2
					) {
						const $el = jQuery(this)
							.children('.ll_logo_carousel_logos_item_wrapper')
							.first();
						$el.animate(
							{
								'margin-left': '-178px',
							},
							1000,
							function () {
								const $parent = $el.parent();
								$el.remove();
								$el.css('margin-left', 0);
								$parent.append($el);
							},
						);
					}
				});
			}, 4000);
		}
	}
}

const instance = new WidgetLogoCarousel();
export default instance;
